// extracted by mini-css-extract-plugin
export var numpadContainer = "_pt-1";
export var phoneButton = "_pt-0";